import { z } from 'zod'

import { FavoriteApi } from '../api'
import { getApiConfig } from './api-config'

const favoriteSchema = z.object({
  id: z.number(),
  contentfulType: z.string(),
  contentfulId: z.string(),
  userId: z.number(),
})

export interface AddFavoriteParams {
  userId: number
  contentfulType: string | null
  contentfulId: string | null
}

export async function fetchFavorites() {
  const api = new FavoriteApi(getApiConfig())
  const dtos = await api.apiFavoriteGet()

  return z.array(favoriteSchema).parse(dtos)
}

export async function addFavorite(params: AddFavoriteParams) {
  const api = new FavoriteApi(getApiConfig())
  await api.apiFavoritePost({
    favoriteItem: {
      userId: params.userId,
      contentfulType: params.contentfulType,
      contentfulId: params.contentfulId,
    },
  })
}

export async function removeFavorite(contentfulId: string) {
  const api = new FavoriteApi(getApiConfig())
  await api.apiFavoriteDelete({ contentfulId })
}
